import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const ClientsIcon = ({
  open,
  disabled,
  currentImage,
  isExpanded,
  returnPath,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.clients;
    const expanded = isExpanded === `panel${MENU_KEYS.clients}`;
    const path = returnPath('/clientes');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };

  if (disabled && currentImage !== MENU_KEYS.clients) {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8 17.4444C24.8 19.899 22.8301 21.8889 20.4 21.8889C17.9699 21.8889 16 19.899 16 17.4444C16 14.9898 17.9699 13 20.4 13C22.8301 13 24.8 14.9898 24.8 17.4444ZM22.6001 17.4443C22.6001 16.217 21.6152 15.2221 20.4001 15.2221C19.1851 15.2221 18.2001 16.217 18.2001 17.4443C18.2001 18.6716 19.1851 19.6666 20.4001 19.6666C21.6152 19.6666 22.6001 18.6716 22.6001 17.4443Z"
          fill="#757A96"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5001 20.7777C32.5001 22.6187 31.0227 24.1111 29.2001 24.1111C27.3776 24.1111 25.9001 22.6187 25.9001 20.7777C25.9001 18.9368 27.3776 17.4444 29.2001 17.4444C31.0227 17.4444 32.5001 18.9368 32.5001 20.7777ZM30.3001 20.7777C30.3001 20.164 29.8076 19.6666 29.2001 19.6666C28.5926 19.6666 28.1001 20.164 28.1001 20.7777C28.1001 21.3913 28.5926 21.8888 29.2001 21.8888C29.8076 21.8888 30.3001 21.3913 30.3001 20.7777Z"
          fill="#757A96"
        />
        <path
          d="M26.134 28.3889C27.097 27.634 28.281 27.2236 29.5 27.2222C32.5376 27.2222 35 29.7095 35 32.7778C35 33.3914 34.5075 33.8889 33.9 33.8889C33.2925 33.8889 32.8 33.3914 32.8 32.7778C32.799 32.0292 32.5487 31.3028 32.0892 30.7154C30.9592 29.271 28.884 29.0253 27.454 30.1667C28.0771 31.3062 28.4026 32.5872 28.4 33.8889C28.4 34.5026 27.9075 35 27.3 35C26.6925 35 26.2 34.5025 26.2 33.8889C26.2 30.8207 23.7376 28.3333 20.7 28.3333C17.6624 28.3333 15.2 30.8207 15.2 33.8889C15.2 34.5025 14.7075 35 14.1 35C13.4925 35 13 34.5025 13 33.8889C13.0027 31.835 13.8096 29.8657 15.2446 28.4105C18.2457 25.3671 23.1211 25.3575 26.134 28.3889Z"
          fill="#757A96"
        />
      </svg>
    );
  }
  return (
    <>
      {logicOp() ? (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" fill="#F4F2F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.8 17.4444C24.8 19.899 22.8301 21.8889 20.4 21.8889C17.9699 21.8889 16 19.899 16 17.4444C16 14.9898 17.9699 13 20.4 13C22.8301 13 24.8 14.9898 24.8 17.4444ZM22.6001 17.4443C22.6001 16.217 21.6152 15.2221 20.4001 15.2221C19.1851 15.2221 18.2001 16.217 18.2001 17.4443C18.2001 18.6716 19.1851 19.6666 20.4001 19.6666C21.6152 19.6666 22.6001 18.6716 22.6001 17.4443Z"
            fill="#6D46DD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.5001 20.7777C32.5001 22.6187 31.0227 24.1111 29.2001 24.1111C27.3776 24.1111 25.9001 22.6187 25.9001 20.7777C25.9001 18.9368 27.3776 17.4444 29.2001 17.4444C31.0227 17.4444 32.5001 18.9368 32.5001 20.7777ZM30.3001 20.7777C30.3001 20.164 29.8076 19.6666 29.2001 19.6666C28.5926 19.6666 28.1001 20.164 28.1001 20.7777C28.1001 21.3913 28.5926 21.8888 29.2001 21.8888C29.8076 21.8888 30.3001 21.3913 30.3001 20.7777Z"
            fill="#6D46DD"
          />
          <path
            d="M26.134 28.3889C27.097 27.634 28.281 27.2236 29.5 27.2222C32.5376 27.2222 35 29.7095 35 32.7778C35 33.3914 34.5075 33.8889 33.9 33.8889C33.2925 33.8889 32.8 33.3914 32.8 32.7778C32.799 32.0292 32.5487 31.3028 32.0892 30.7154C30.9592 29.271 28.884 29.0253 27.454 30.1667C28.0771 31.3062 28.4026 32.5872 28.4 33.8889C28.4 34.5026 27.9075 35 27.3 35C26.6925 35 26.2 34.5025 26.2 33.8889C26.2 30.8207 23.7376 28.3333 20.7 28.3333C17.6624 28.3333 15.2 30.8207 15.2 33.8889C15.2 34.5025 14.7075 35 14.1 35C13.4925 35 13 34.5025 13 33.8889C13.0027 31.835 13.8096 29.8657 15.2446 28.4105C18.2457 25.3671 23.1211 25.3575 26.134 28.3889Z"
            fill="#6D46DD"
          />
        </svg>
      ) : (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" fill="#525067" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.8 17.4444C24.8 19.899 22.8301 21.8889 20.4 21.8889C17.9699 21.8889 16 19.899 16 17.4444C16 14.9898 17.9699 13 20.4 13C22.8301 13 24.8 14.9898 24.8 17.4444ZM22.6001 17.4443C22.6001 16.217 21.6152 15.2221 20.4001 15.2221C19.1851 15.2221 18.2001 16.217 18.2001 17.4443C18.2001 18.6716 19.1851 19.6666 20.4001 19.6666C21.6152 19.6666 22.6001 18.6716 22.6001 17.4443Z"
            fill="#F4F2F9"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.5001 20.7777C32.5001 22.6187 31.0227 24.1111 29.2001 24.1111C27.3776 24.1111 25.9001 22.6187 25.9001 20.7777C25.9001 18.9368 27.3776 17.4444 29.2001 17.4444C31.0227 17.4444 32.5001 18.9368 32.5001 20.7777ZM30.3001 20.7777C30.3001 20.164 29.8076 19.6666 29.2001 19.6666C28.5926 19.6666 28.1001 20.164 28.1001 20.7777C28.1001 21.3913 28.5926 21.8888 29.2001 21.8888C29.8076 21.8888 30.3001 21.3913 30.3001 20.7777Z"
            fill="#F4F2F9"
          />
          <path
            d="M26.134 28.3889C27.097 27.634 28.281 27.2236 29.5 27.2222C32.5376 27.2222 35 29.7095 35 32.7778C35 33.3914 34.5075 33.8889 33.9 33.8889C33.2925 33.8889 32.8 33.3914 32.8 32.7778C32.799 32.0292 32.5487 31.3028 32.0892 30.7154C30.9592 29.271 28.884 29.0253 27.454 30.1667C28.0771 31.3062 28.4026 32.5872 28.4 33.8889C28.4 34.5026 27.9075 35 27.3 35C26.6925 35 26.2 34.5025 26.2 33.8889C26.2 30.8207 23.7376 28.3333 20.7 28.3333C17.6624 28.3333 15.2 30.8207 15.2 33.8889C15.2 34.5025 14.7075 35 14.1 35C13.4925 35 13 34.5025 13 33.8889C13.0027 31.835 13.8096 29.8657 15.2446 28.4105C18.2457 25.3671 23.1211 25.3575 26.134 28.3889Z"
            fill="#F4F2F9"
          />
        </svg>
      )}
    </>
  );
};

export default ClientsIcon;
